import React, { Component } from 'react';
import styles from './list-heading.scss';

export class ListHeading extends Component<{ translation }> {

  public render() {
    const { translation } = this.props;

    return <div className={styles.headingContainer}>
      <div className={`${styles.defaultColumn} ${styles.wider}`}>{translation.subscriber_group}</div>
      <div className={`${styles.defaultColumn} ${styles.wider}`}>{translation.criteria}</div>
      <div className={styles.defaultColumn}>{translation.case_type}</div>
      <div className={styles.defaultColumn}>{translation.operation}</div>
      <div className={styles.fixedColumn} />
    </div>;
  }
}
